export default __webpack_public_path__ + "static/2025-img-articolo-gennaio1-7366e0b7e7a9614d4e666511a296dca7.jpg";